import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { getSeriesColors } from '../../dashboardChartColors';

const CHART_HEIGHT = 280;

function DashboardRadialChart({ series = [], percentage = false }) {
    const labels = series.map((item) => item.label);
    const values = series.map((item) => item.value);
    const colors = getSeriesColors(series);

    const options = {
        chart: {
            type: 'radialBar',
            toolbar: { show: false },
            animations: { enabled: true, easing: 'easeinout', speed: 800 },
        },
        colors,
        labels,
        plotOptions: {
            radialBar: {
                offsetY: 0,
                startAngle: 0,
                endAngle: 270,
                hollow: {
                    margin: 8,
                    size: '38%',
                    background: 'transparent',
                },
                track: {
                    background: '#f1f3f8',
                    strokeWidth: '100%',
                    margin: 6,
                },
                dataLabels: {
                    name: {
                        fontSize: '12px',
                        color: '#5e6278',
                        offsetY: -4,
                    },
                    value: {
                        fontSize: '18px',
                        fontWeight: 700,
                        color: '#181c32',
                        offsetY: 4,
                        formatter: (val) => (percentage ? `${val.toFixed(1)}%` : Math.round(val).toLocaleString()),
                    },
                    total: {
                        show: series.length > 1,
                        label: percentage ? 'Avg' : 'Total',
                        fontSize: '11px',
                        color: '#78829d',
                        formatter: (w) => {
                            const total = w.globals.seriesTotals.reduce((sum, val) => sum + val, 0);
                            if (percentage) {
                                return `${(total / w.globals.series.length).toFixed(1)}%`;
                            }
                            return Math.round(total).toLocaleString();
                        },
                    },
                },
            },
        },
        stroke: { lineCap: 'round' },
        legend: {
            show: series.length > 3,
            position: 'bottom',
            fontSize: '12px',
        },
    };

    return (
        <ReactApexChart
            options={options}
            series={values}
            type="radialBar"
            height={CHART_HEIGHT}
            width="100%"
        />
    );
}

export default DashboardRadialChart;
